<template>
  <el-container class="add-dialog">
    <header>添加新闻
      <i class="iconfont icon-close" @click="dialogClose"></i>
    </header>
    <div class="content">
      <div class="banner">
        <div class="h3">新闻</div>
      </div>
      <div class="form">
        <div class="form-header">基本信息</div>
        <div class="form-content">
          <!-- 标题 -->
          <div class="form-item single">
            <span class="item-title"><span class="need">*</span>标题</span>
            <div class="item-right">
              <el-input v-model.trim="title" placeholder="请输入(必填)" size="medium" maxlength="100"></el-input>
            </div>
            <div class="err" v-if="err_title"><i class="el-icon-warning"></i>{{err_title}}</div>
          </div>
          <!-- 发布网站 -->
          <div class="form-item single50">
            <span class="item-title"><span class="need">*</span>发布网站</span>
            <div class="item-right">
              <el-select v-model="siteValue" placeholder="请选择(必填)" @change="getNewsSortList('siteChange')">
                <el-option v-for="item in siteList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </div>
            <div class="err" v-if="err_site"><i class="el-icon-warning"></i>{{err_site}}</div>
          </div>
          <!-- 分类 -->
          <div class="form-item single50">
            <span class="item-title"><span class="need">*</span>分类</span>
            <div class="item-right">
              <el-select v-model="typeValue" placeholder="请选择(必填)">
                <el-option v-for="item in typeList" :key="item.id" :label="item.type_name" :value="item.id"></el-option>
              </el-select>
            </div>
            <div class="err" v-if="err_type"><i class="el-icon-warning"></i>{{err_type}}</div>
          </div>
          <!-- 列表图片 -->
          <div class="form-item single50">
            <span class="item-title"><span class="need">*</span>列表图片</span>
            <div class="item-right">
              <div class="upload" @click="fileApply($event, 1)"><i class="iconfont icon-Rectangle"></i> 上传图片</div>
              <input type="file" id="fileApply" hidden @change="fileApply($event)" accept="image/*"/>
              <div class="upload-box" v-if="listImg">
                <img class="upload-img" :src="baseURL + listImg.file_url + '&TOKEN=' + token" alt="">
              </div>
            </div>
            <div class="err" v-if="err_upload"><i class="el-icon-warning"></i>{{err_upload}}</div>
          </div>
          <!-- 列表视频 -->
          <div class="form-item single50">
            <span class="item-title">列表视频</span>
            <div class="item-right">
              <div class="upload" @click="videoApply($event, 1)"><i class="iconfont icon-Rectangle"></i> 上传视频</div>
              <input type="file" id="videoApply" hidden @change="videoApply($event)" accept="video/*"/>
              <div class="upload-box-file" v-for="(v, vi) in listVideo" :key="vi">
                <i class="iconfont icon-icon-pc-paper-mp video-icon"></i>
                <span class="info">
                  <p class="first">{{v.file_name}}</p>
                  <p class="second">{{v.file_size | fileSize()}}</p>
                </span>
              </div>
            </div>
            <div class="err" v-if="err_upload"><i class="el-icon-warning"></i>{{err_upload}}</div>
          </div>
          <!-- 内容 -->
          <div class="form-item single">
            <span class="item-title"><span class="need">*</span>内容</span>
            <div class="item-right">
              <ueditor :editorContent="editorContent" v-if="(editorContent != '' && currentId != '') || currentId == ''" :isEdit="true"></ueditor>
            </div>
            <div class="err" v-if="err_editor"><i class="el-icon-warning"></i>{{err_editor}}</div>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <el-button @click="dialogClose">取 消</el-button>
      <el-button type="primary" @click="dialogSave(1)">发 布</el-button>
      <el-button @click="dialogSave(2)">暂 存</el-button>
    </footer>
  </el-container>
</template>
<script>
import ueditor from '@/common/components/ueditor.vue'
import {baseURL2} from '@/common/js/ajax.js'
export default {
  components: {
    ueditor
  },
  props: ['currentId', 'isEdit'],
  data () {
    return {
      title: '', // 标题
      baseURL: baseURL2,
      siteValue: 1, // 发布网站
      siteList: [{value: 1, label: '官网'}, {value: 2, label: '定制网'}],
      typeValue: '', // 分类
      typeList: [],
      token: JSON.parse(sessionStorage.getItem('requestHeader')).TOKEN,
      listImg: '', // 列表图片
      listVideo: [], // 列表视频
      editorHTML: '', // 编辑器内容
      editorContent: '<p></p>', // 设置编辑器内容
      err_title: '', // 标题
      err_site: '', // 发布网站
      err_type: '', // 分类
      err_upload: '', // 列表图片
      err_editor: '' // 内容
    }
  },
  created () {
    console.log(this.currentId, this.isEdit)
    // 获取分类列表
    if (this.currentId) {
      this.getDetail(this.currentId).then(() => {
        this.getNewsSortList()
      })
    } else {
      this.getNewsSortList()
    }
  },
  mounted () {
    this.$bus.on('editorContents', res => {
      this.editorHTML = res
    })
  },
  methods: {
    // 根据id获取新闻详情
    getDetail (id) {
      return new Promise((resolve) => {
        this.$http.webNewsQueryNewsDetail({'id': id}).then(res => {
          this.title = res.new_title
          this.siteValue = res.source
          this.typeValue = res.type_id
          this.listImg = res.images[0]
          this.listVideo = res.videos
          this.editorContent = res.content
          resolve()
        })
      })
    },
    // 获取新闻分类 source （1官网，2定制网）为空默认获取所有
    getNewsSortList (str) {
      if (str === 'siteChange') {
        // 选择官网调用
        // 此时分类默认选择全部
        this.typeValue = ''
      }
      this.$http.newsQueryNewType({'source': this.siteValue}).then(res => {
        this.typeList = res.dataList
        // 分类选项加全部
        this.typeList.unshift({id: '', type_name: '全部'})
      })
    },
    // 提交数据
    dialogSave (newStatus) {
      let b = this.dataTraversal()
      if (b) {
        let arr = []
        arr.push(this.listImg)
        let obj = {
          'new_title': this.title, // string新闻名称
          'source': this.siteValue, // int新闻分类来源（1官网，2定制网）
          'type_id': this.typeValue, // long新闻分类
          'images': arr, // jsonArray图片 格式参照《后台获取新闻列表》的images结构
          'content': this.editorHTML, // string新闻内容
          'videos': this.listVideo,
          'new_status': newStatus// int新闻状态（1，发布，2暂存/未发布）
        }
        if (this.isEdit) {
          // 编辑 newsUpdateNews
          obj.id = this.currentId
          this.$http.newsUpdateNews(obj).then(res => {
            this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!'
            })
            // 关窗(刷新列表)
            this.dialogClose('refreshList')
          })
          console.log(obj)
        } else {
          // 新增
          this.$http.newsAddNews(obj).then(res => {
            this.$message({
              showClose: true,
              type: 'success',
              message: '保存成功!'
            })
            // 关窗(刷新列表)
            this.dialogClose('refreshList')
          })
        }
      }
    },
    /** 数据遍历 */
    dataTraversal () {
      this.err_title = ''
      this.err_site = ''
      this.err_type = ''
      this.err_upload = ''
      this.err_editor = ''
      if (!this.title) {
        this.err_title = '标题不能为空'
        return false
      }
      if (!this.siteValue) {
        this.err_site = '发布网站不能为空'
        return false
      }
      // if (!this.typeValue) {
      //   this.err_type = '分类不能为空'
      //   return false
      // }
      if (!this.listImg) {
        this.err_upload = '列表图片不能为空'
        return false
      }
      if (!this.editorHTML) {
        this.err_editor = '内容不能为空'
        return false
      }
      return true
    },
    dialogClose (tag) {
      this.$bus.emit('closeAddNews', tag)
    },
    // 上传文件
    fileApply (e, type) {
      if (type === 1) {
        if (e.target.className.indexOf('disable') < 0) {
          document.getElementById('fileApply').click()
        }
      } else {
        if (!e.target.value) {
          console.log('为空！！！')
          return
        }
        var file = event.target.files[0]
        var fileType = file.type
        if (fileType.split('/')[0] === 'image') {
          let formdata = new FormData()
          formdata.append('userlogo', file)
          formdata.append('bean', 'user')
          this.$http.imageUpload(formdata, 'Loading').then((res) => {
            res.map((item) => {
              this.listImg = item
            })
          })
        }
        e.target.value = ''
      }
    },
    // 上传文件
    videoApply (e, type) {
      if (type === 1) {
        if (e.target.className.indexOf('disable') < 0) {
          document.getElementById('videoApply').click()
        }
      } else {
        if (!e.target.value) {
          console.log('为空！！！')
          return
        }
        var file = event.target.files[0]
        var fileType = file.type
        if (fileType.split('/')[0] === 'video') {
          let formdata = new FormData()
          formdata.append('userlogo', file)
          formdata.append('bean', 'user')
          this.$http.imageUpload(formdata, 'Loading').then((res) => {
            this.listVideo = res
            // res.map((item) => {
            //   this.listVideo = item
            // })
          })
        }
        e.target.value = ''
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/news/news-add.vue